import TCreateEditArticle from "types/Clients/WhaleShark/articles/createEditArticle";

export const checkEmptyCoverImage = (editedItem: TCreateEditArticle) => {
  if (editedItem.coverImage === undefined) {
    editedItem.coverImage = null;
  }
};
